import { createApp } from '@wu/widget-core';
import { meta } from './meta';
import { Slider } from './Slider';

const { appAlias: alias, appName: name } = meta;

export default createApp({ alias, name }, Slider);
